<template>
  <div id="pageRoot">
    <img id="beehive" class="pageElement basicItem01" src="/pages/img/sordocas/svgCas15Beehive.svg" />
    <img id="trees" class="pageElement basicItem01" src="/pages/img/sordocas/svgCas15Trees.svg" />
    <img id="anthill" class="pageElement basicItem01" src="/pages/img/sordocas/svgCas15Anthill.svg" />
    <img id="princess" class="pageElement basicItem01" src="/pages/img/sordocas/svgCas15Princess.svg" />

    <div id="radio0">
      <label class="toggleButtonContainer pageElement" id="toggle01"
        >COLINA
        <input type="radio"
        name="colina"
        ref="1-1" 
        v-on:change="saveOption('radios', 1, 1)" 
        :onload="loadOption('radios', 1, 1)"/>
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle02"
        >COMETA
        <input type="radio"
        name="colina"
        ref="1-2" 
        v-on:change="saveOption('radios', 1, 2)" 
        :onload="loadOption('radios', 1, 2)"/>
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle03"
        >COLMENA
        <input type="radio"
        name="colina"
        ref="1-3" 
        v-on:change="saveOption('radios', 1, 3)" 
        :onload="loadOption('radios', 1, 3)"/>
        <span class="toggleButton"></span>
      </label>
    </div>

    <div id="radio1">
      <label class="toggleButtonContainer pageElement" id="toggle11"
        >BOTE
        <input type="radio"
        name="bote"
        ref="2-1" 
        v-on:change="saveOption('radios', 2, 1)" 
        :onload="loadOption('radios', 2, 1)"/>
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle12"
        >BOSQUE
        <input type="radio"
        name="bote"
        ref="2-2" 
        v-on:change="saveOption('radios', 2, 2)" 
        :onload="loadOption('radios', 2, 2)"/>
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle13"
        >BROCHE
        <input type="radio"
        name="bote"
        ref="2-3" 
        v-on:change="saveOption('radios', 2, 3)" 
        :onload="loadOption('radios', 2, 3)"/>
        <span class="toggleButton"></span>
      </label>
    </div>

    <div id="radio2">
      <label class="toggleButtonContainer pageElement" id="toggle21"
        >HELADO
        <input type="radio"
        name="helado"
        ref="3-1" 
        v-on:change="saveOption('radios', 3, 1)" 
        :onload="loadOption('radios', 3, 1)"/>
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle22"
        >HORMIGUERO
        <input type="radio"
        name="helado"
        ref="3-2" 
        v-on:change="saveOption('radios', 3, 2)" 
        :onload="loadOption('radios', 3, 2)"/>
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle23"
        >HIELO
        <input type="radio"
        name="helado"
        ref="3-3" 
        v-on:change="saveOption('radios', 3, 3)" 
        :onload="loadOption('radios', 3, 3)"/>
        <span class="toggleButton"></span>
      </label>
    </div>

    <div id="radio3">
      <label class="toggleButtonContainer pageElement" id="toggle31"
        >CAROLINA
        <input type="radio"
        name="carolina"
        ref="4-1" 
        v-on:change="saveOption('radios', 4, 1)" 
        :onload="loadOption('radios', 4, 1)"/>
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle32"
        >CATALINA
        <input type="radio"
        name="carolina"
        ref="4-2" 
        v-on:change="saveOption('radios', 4, 2)" 
        :onload="loadOption('radios', 4, 2)"/>
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle33"
        >CAMILA
        <input type="radio"
        name="carolina"
        ref="4-3" 
        v-on:change="saveOption('radios', 4, 3)" 
        :onload="loadOption('radios', 4, 3)"/>
        <span class="toggleButton"></span>
      </label>
    </div>
  </div>
</template>
<style scoped>
#beehive {
  position: absolute;
  left: 32px;
  top: 180px;
}
#trees {
  position: absolute;
  left: 496px;
  top: 160px;
}
#anthill {
  position: absolute;
  left: 8px;
  top: 501px;
}
#princess {
  position: absolute;
  left: 568px;
  top: 470px;
}

#toggle01 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 213px;
  top: 193px;
}
#toggle02 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 213px;
  top: 248px;
}
#toggle03 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 213px;
  top: 302px;
}

#toggle11 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 186px;
}
#toggle12 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 240px;
}
#toggle13 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 293px;
}

#toggle21 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 216px;
  top: 497px;
}
#toggle22 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 216px;
  top: 551px;
}
#toggle23 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 216px;
  top: 604px;
}

#toggle31 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 497px;
}
#toggle32 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 551px;
}
#toggle33 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 604px;
}
</style>
<script>
  export default {
    data() {
    return {
      videos: [
        "cas/Video 34.mp4",
        "cas/Video 35.mp4",
        "cas/Video 36.mp4",
        "cas/Video 37.mp4",
      ],
    };
  },
    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>